// Словарь подпроекта 9 «ЭДО (Диадок)»: подключение, клиент в ЭДО, состояние. Подключается в `ru.ts`.

/** «ЭДО» в настройках, карточке клиента и «Сегодня» (ключи `edo.*`). */
export const ruEdo = {
  provider: 'Диадок',
  title: 'ЭДО',
  lead: 'Документы с клиентами — сразу в их ящик ЭДО, подпись студии — облачной УКЭП с подтверждением на телефоне',
  hint: {
    title: 'Что такое ЭДО и УКЭП',
    text: 'ЭДО — электронный документооборот: клиент получает заявку, акты и счета в свой ящик (Диадок, СБИС и другие операторы через роуминг) и подписывает их там своей квалифицированной подписью — УКЭП. Такие документы равны бумажным с печатью. Студия подписывает облачной УКЭП подписанта прямо в платформе: нажал «Подписать УКЭП» — подтвердил в приложении на телефоне',
    example:
      'Клиент работает в Диадоке — акт уходит ему в ящик сразу после подписи студии, статус «Подписан контрагентом» приходит сам',
  },
  connection: {
    title: 'Подключение',
    lead: 'Ключи интегратора вводит администратор, входит через Контур и выбирает сертификат — подписант студии',
    steps: {
      keys: 'Ключи интегратора',
      login: 'Вход подписанта',
      box: 'Ящик студии',
      certificate: 'Сертификат для подписи',
    },
    clientId: 'client_id',
    clientIdHint: 'Идентификатор интегратора — выдаёт менеджер Диадока после заявки на доступ к API',
    secret: 'API-ключ',
    secretHint: 'Кабинет интегратора → «API-ключи». Хранится зашифрованным и назад не показывается',
    keysHint: {
      title: 'Где взять ключи',
      text: 'Подайте заявку на доступ к API Диадока — менеджер пришлёт client_id. В Кабинете интегратора создайте API-ключ, выберите способ получения токенов «AuthorizationCode» и впишите адрес возврата ниже. Настройки Кабинета вступают в силу примерно через 5 минут',
      example: 'client_id вида glory-studio-1a2b, API-ключ — длинная строка из Кабинета',
    },
    openRequest: 'Заявка на доступ к API',
    openCabinet: 'Кабинет интегратора',
    redirect: 'Адрес возврата для Кабинета',
    redirectHint: {
      title: 'Адрес возврата',
      text: 'Сюда Контур возвращает подписанта после входа. Без него в Кабинете интегратора вход не сработает. Адрес должен открываться по HTTPS',
      example: 'https://штат.студия.рф/hooks/diadoc/callback',
    },
    copy: 'Скопировать',
    copied: 'Адрес скопирован',
    saveKeys: 'Сохранить ключи',
    keysSaved: 'Ключи сохранены — теперь подписант входит через Контур',
    keysSavedState: 'client_id {clientId} · API-ключ {mask}',
    keysByAdmin: 'Ключи интегратора вводит администратор в этих настройках',
    secretUnreadable: 'ключ шифрования недоступен',
    replaceKeys: 'Заменить ключи',
    keepKeys: 'Не менять',
    login: 'Войти через Контур',
    relogin: 'Войти заново',
    loginHint: {
      title: 'Почему входит подписант',
      text: 'Облачной УКЭП подписывают только своим сертификатом, поэтому Диадок подключает тот, кто подписывает за студию. Вход действует, пока платформа обращается к Диадоку хотя бы раз в 30 дней — синхронизация раз в минуту держит его живым',
      example:
        'Подписант — директор: он нажимает «Войти через Контур» и входит своей учётной записью Контура',
    },
    loginOnlySigner: 'Войти должен подписант студии: {name}',
    noSigner: 'Подписант студии не указан — выберите его в Настройках → Реквизиты',
    loggedIn: 'Вошёл {name} · {at}',
    loggedInUnknown: 'Вход выполнен · {at}',
    loginDone: 'Диадок подключён: {org}',
    loginFailed: 'Не удалось войти через Контур: {message}',
    box: '{name} · ИНН {inn}',
    boxKpp: '{name} · ИНН {inn} · КПП {kpp}',
    boxNone: 'Ящик появится после входа подписанта',
    certificate: 'Сертификат для подписи',
    certificateHint: {
      title: 'Облачный сертификат',
      text: 'Подписывать в платформе можно облачным сертификатом подписанта: Госключом или облачной КЭП Контура. Сертификат на носителе (токене) облачно не подписывает. Сотрудник, а не руководитель, подписывает по машиночитаемой доверенности — её регистрируют в Диадоке',
      example:
        'Госключ директора, действует до 12.08.2027 — выберите его, и «Подписать УКЭП» появится у документов',
    },
    certificateLead: 'Выберите облачный сертификат — им вы будете подписывать документы в платформе',
    certificateLater: 'Сертификаты появятся после входа подписанта',
    certificateInn: 'ИНН {inn}',
    certificatesEmpty:
      'У подписанта нет облачных сертификатов — выпустите Госключ или облачную КЭП Контура и обновите список',
    certificatesRefresh: 'Обновить список',
    certificatesRefreshed: 'Список сертификатов обновлён',
    certificateChoose: 'Выбрать',
    certificateChosen: 'Выбран',
    certificateSaved: 'Сертификат для подписи: {owner}',
    certificateValid: 'Действует до {date}',
    certificateExpiring: 'Истекает {date}',
    certificateExpired: 'Истёк {date}',
    certificateNotYet: 'Действует с {date}',
    certificateToken: 'На носителе — облачно не подписать',
    certificateOnlySigner: 'Выбирает сертификат подписант студии',
    kinds: { dss: 'Облачная КЭП', goskey: 'Госключ', token: 'На носителе' },
  },
  states: { active: 'Работает', paused: 'На паузе', error: 'Ошибка' },
  state: {
    title: 'Состояние',
    lead: 'Статусы документов приходят из ленты событий Диадока раз в минуту',
    ok: 'Работает · {ago}',
    never: 'Первая синхронизация — в течение минуты',
    paused: 'На паузе — статусы не обновляются, документы в ЭДО не уходят',
    error: 'Не синхронизируется',
    lastError: 'Последняя ошибка: {message}',
    pause: 'Пауза',
    resume: 'Продолжить',
    pausedToast: 'ЭДО на паузе',
    resumedToast: 'ЭДО снова работает',
    disconnect: 'Отключить',
    disconnectHint:
      'Ключи и вход удалятся из платформы, документы снова пойдут ссылкой. Отправленное в ЭДО останется в Диадоке',
    disconnected: 'ЭДО отключено',
    delayHint: {
      title: 'Почему статус приходит с задержкой',
      text: 'У Диадока нет вебхуков: платформа читает ленту событий ящика студии раз в минуту с того места, где остановилась, поэтому ничего не теряется, но «Подписан контрагентом» появляется в течение минуты',
      example: 'Клиент подписал акт в 15:10 — к 15:11 он подписан и здесь',
    },
  },
  client: {
    title: 'ЭДО',
    hint: {
      title: 'Клиент в ЭДО',
      text: 'Платформа ищет клиента у операторов ЭДО по ИНН и КПП: найден — документы могут уходить в его ящик. Если он ещё не контрагент студии, с первыми документами ему уйдёт приглашение. Проверка обновляется сама при отправке документов и не чаще раза в сутки',
      example: 'ООО «Ромашка» найдено в Диадоке и уже контрагент — акт уйдёт ему сразу после подписи студии',
    },
    statuses: {
      not_found: 'Не найден в ЭДО',
      found: 'Найден в ЭДО',
      invited: 'Приглашение отправлено',
      counteragent: 'Контрагент',
      rejected: 'Отказался от обмена',
    },
    org: '{name}',
    checkedAt: 'проверено {ago}',
    notChecked: 'Ещё не проверяли',
    check: 'Проверить в ЭДО',
    checked: 'Проверили: {status}',
    notConnected: 'ЭДО студии не подключено — Настройки → ЭДО',
    person: 'У физлица ЭДО нет — документы уходят ссылкой на подписание',
    noInn: 'Укажите ИНН — по нему клиента ищут в ЭДО',
    noKpp: 'Укажите КПП — по ИНН и КПП организацию ищут в ЭДО',
    docflow: 'Документы через ЭДО',
    docflowHint: {
      title: 'Документы через ЭДО',
      text: 'Включено — заявка, акты, счета и допсоглашения уходят клиенту в ящик ЭДО сразу после подписи студии, без ссылки. Выключено — письмом со ссылкой на страницу подписания, как раньше. Клиент может и сам выбрать ЭДО на странице подписания — тогда переключатель включится',
      example: 'Бухгалтерия клиента просит всё через Диадок — включите, и ссылки больше не понадобятся',
    },
    docflowOn: 'Документы клиента пойдут в его ЭДО',
    docflowOff: 'Документы клиента пойдут ссылкой',
    unreachable: 'Пока клиента нет в ЭДО, документы уходят ссылкой',
  },
  today: {
    error: 'ЭДО не синхронизируется',
    open: 'Открыть настройки ЭДО',
  },
} as const;

/** Ошибки ЭДО (в `errors.edo`). */
export const ruEdoErrors = {
  not_connected: 'ЭДО не подключено: Настройки → ЭДО',
  unauthorized: 'Вход в Контур больше не действует — войдите заново в Настройках → ЭДО',
  keys_required: 'Сначала сохраните client_id и API-ключ: Настройки → ЭДО',
  keys_invalid: 'Контур не принял client_id или API-ключ — проверьте их в Кабинете интегратора',
  foreign_box: 'Ящик Диадока принадлежит ИНН {inn}, а в реквизитах студии другой',
  no_box: 'У учётной записи Контура нет ящика Диадока — зарегистрируйте организацию в Диадоке',
  not_signer: 'Подключить ЭДО и подписывать УКЭП может только подписант студии',
  no_refresh:
    'Контур не выдал постоянный вход — в Кабинете интегратора разрешите refresh-токены (offline_access) и войдите снова',
  login_expired: 'Окно входа устарело — нажмите «Войти через Контур» ещё раз',
  login_denied: 'Вход через Контур отменён',
  certificate_required: 'Выберите сертификат для подписи в Настройках → ЭДО',
  certificate_expired: 'Сертификат истёк {date} — выберите новый в Настройках → ЭДО',
  certificate_unusable: 'Этим сертификатом облачно не подписать — выберите облачную КЭП или Госключ',
  sign_not_confirmed: 'Подпись не подтверждена в приложении — попробуйте ещё раз',
  client_not_found: 'Клиент не найден в ЭДО — отправьте ссылкой',
  client_requisites: 'Для УПД не хватает {fields} клиента',
  client_person: 'У физлица ЭДО нет — документы уходят ссылкой на подписание',
  client_inn: 'Укажите ИНН клиента — по нему ищут в ЭДО',
  client_kpp: 'Укажите КПП организации — по ИНН и КПП ищут в ЭДО',
  invitation_pending: 'Клиент ещё не принял приглашение в ЭДО',
  paused: 'ЭДО на паузе — продолжите в Настройках → ЭДО',
  unavailable: 'Диадок не отвечает — попробуем ещё раз через минуту',
  rejected: 'Диадок отклонил запрос: {message}',
  bad_response: 'Диадок ответил не так, как ожидалось — попробуем ещё раз через минуту',
  sync_failed:
    'Не удалось разобрать ленту событий Диадока — повторим через минуту. Если ошибка не уйдёт, напишите разработчикам',
} as const;

/** «История» и журнал (в `audit`). */
export const ruEdoAudit = {
  actions: {
    edo_connection: {
      keys_saved: 'Сохранены ключи Диадока',
      keys_changed: 'Заменены ключи Диадока',
      logged_in: 'Подписант вошёл в Диадок',
      certificate_chosen: 'Выбран сертификат для подписи',
      paused: 'ЭДО на паузе',
      resumed: 'ЭДО продолжено',
      disconnected: 'ЭДО отключено',
    },
  },
  entities: {
    edo_connection: 'Подключение ЭДО',
  },
  fields: {
    edoClientId: 'client_id Диадока',
    edoAccount: 'Учётная запись Контура',
    edoOrg: 'Организация в Диадоке',
    edoCertificate: 'Сертификат для подписи',
    edoState: 'Состояние ЭДО',
    edoStatus: 'В ЭДО',
  },
} as const;

/** Действия с клиентом (в `audit.actions.client`). */
export const ruEdoClientAudit = {
  edo_checked: 'Клиент проверен в ЭДО',
} as const;

/** Типы уведомлений (в `notifications`). */
export const ruEdoNotificationTypes = {
  typeEdoLogin: 'ЭДО: вход в Контур не действует',
  typeEdoLoginHint:
    'Подписанту и администраторам: вход подписанта перестал действовать (30 дней без работы, права отозваны) — раз в день',
  typeEdoCertificate: 'Сертификат для ЭДО истекает',
  typeEdoCertificateHint:
    'Подписанту и администраторам: за 14 и 3 дня до конца срока облачного сертификата и в день истечения',
} as const;

/** Тексты уведомлений (в `edo.notifications`). */
export const ruEdoNotifications = {
  loginTitle: 'ЭДО: войдите в Контур заново',
  loginBody: 'Пока подписант не войдёт, статусы не обновляются и документы не уходят в ЭДО — Настройки → ЭДО',
  certificateTitle: 'Сертификат для ЭДО истекает {date}',
  certificateExpiredTitle: 'Сертификат для ЭДО истёк {date}',
  certificateBody:
    'Без действующего сертификата «Подписать УКЭП» недоступно — выпустите новый и выберите его в Настройках → ЭДО',
} as const;
